import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { action } from '@ember/object';
import { replace } from '@square/dashboard-utilities/utils/window';
import { generateSavingsAccountUrl } from '@banking/ui/utils/savings-account-url';
import CurrentApplicationFlow from '@banking/api/services/current-application-flow';
import PlaidState from '@banking/ui/services/plaid-state';

export default class LinkWithPlaidController extends Controller {
  @service currentApplicationFlow!: CurrentApplicationFlow;
  @service plaidState!: PlaidState;

  @readOnly('currentApplicationFlow.bankcBalanceId')
  bankcBalanceId!: string;

  @action
  goToGeneralSavings() {
    const url = generateSavingsAccountUrl(this.bankcBalanceId);
    replace(url);
  }

  @action
  async plaidRedirectOnSuccess(publicToken: string, metadata: any) {
    await this.plaidState.plaidOnSuccess(publicToken, metadata);
    this.goToGeneralSavings();
  }
}
